import { NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  Input,
  Renderer2,
  ViewChild,
  type OnChanges,
  type SimpleChanges,
} from '@angular/core';

import { WithToggleDirective } from '../with-toggle/with-toggle.directive';

@Component({
  selector: 'myre-toggle-button',
  template: `
    <div
      #button
      [ngClass]="classes"
      [class.has-ref]="ref"
      [class.disabled]="disabled"
      (click)="onClick()"
    >
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./toggle-button.scss'],
  imports: [NgClass],
})
export class ToggleButtonComponent implements OnChanges {
  public myreWithToggle = inject(WithToggleDirective);
  private _renderer = inject(Renderer2);

  @Input()
  public classes: string;

  @Input()
  public maxHeight: number = null;

  @Input()
  public disabled: boolean = false;

  @Input()
  public ref: HTMLElement;

  @ViewChild('button', { read: ElementRef, static: true })
  private _button: ElementRef;

  public onClick(): void {
    if (!this.disabled) {
      this.myreWithToggle.myreToggle.setOnState(
        !this.myreWithToggle.myreToggle.on,
      );
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if ((changes.ref || changes.maxHeight) && this.ref) {
      this._renderer.setStyle(this.ref, 'position', 'relative');

      if (this.maxHeight !== null) {
        this._renderer.setStyle(
          this._button.nativeElement,
          'max-height',
          this.maxHeight + 'px',
        );
      }
    }
  }
}
